<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.575 9.4L7.675 12.3C7.49167 12.4833 7.25833 12.575 6.975 12.575C6.69167 12.575 6.45833 12.4833 6.275 12.3C6.09167 12.1167 6 11.8833 6 11.6C6 11.3167 6.09167 11.0833 6.275 10.9L10.875 6.3C11.075 6.1 11.3083 6 11.575 6C11.8417 6 12.075 6.1 12.275 6.3L16.875 10.9C17.0583 11.0833 17.15 11.3167 17.15 11.6C17.15 11.8833 17.0583 12.1167 16.875 12.3C16.6917 12.4833 16.4583 12.575 16.175 12.575C15.8917 12.575 15.6583 12.4833 15.475 12.3L12.575 9.4V17.6C12.575 17.8833 12.4792 18.1208 12.2875 18.3125C12.0958 18.5042 11.8583 18.6 11.575 18.6C11.2917 18.6 11.0542 18.5042 10.8625 18.3125C10.6708 18.1208 10.575 17.8833 10.575 17.6V9.4Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
